// removed by extract-text-webpack-plugin
module.exports = {"menu":"Menu__menu___2qsLh","isHiddenDesktop":"Menu__isHiddenDesktop___2iZT5","item":"Menu__item___1F8ui","item__double":"Menu__item__double___aB-eU","item__fullWidth":"Menu__item__fullWidth___17JVs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/Menu/Menu.scss
// module id = 661
// module chunks = 0